import { Control, FieldArrayWithId, useFieldArray } from 'react-hook-form';

import { SortableContainer } from '../../../../../common/ui/draggable-container';
import { TPageForm } from '../../../page-form/page-form';
import { AssetsContainer } from '../../assets-container';
import styles from '../page-videos.module.scss';
import { VideoAsset } from './components/video-asset';
import { VideoAssetCreator } from './components/video-asset-creator';

type Props = {
  control: Control<TPageForm>;
};

const PageVideoAssetsForm = ({ control }: Props) => {
  const { append, fields, move, remove, update } = useFieldArray({
    control,
    name: 'pageVideos',
  });

  const onDeleteButton = (
    assetIdx: number,
    asset: FieldArrayWithId<TPageForm, 'pageVideos'>,
  ) => {
    if (asset.type === 'deleted') return;

    if (asset.type === 'new') {
      remove(assetIdx);
    } else {
      update(assetIdx, { ...asset, type: 'deleted' });
    }
  };

  return (
    <div className="w-100 flex-column raw-gap-20">
      <AssetsContainer basedVisibleCount={4} className={styles.items_container}>
        <div className={styles.item_wrapper}>
          <VideoAssetCreator
            onAddButton={(data) => append(data, { shouldFocus: false })}
          />
        </div>
        {fields.map((asset, assetIdx) => {
          if (asset.type === 'deleted') return null;

          return (
            <SortableContainer.ItemWrapper
              key={asset.id}
              className={styles.item_wrapper}
              id={asset.id}
              index={assetIdx}
              moveItem={(from, to) => move(from, to)}
            >
              <VideoAsset
                assetIdx={assetIdx}
                data={asset}
                onDeleteButton={() => onDeleteButton(assetIdx, asset)}
                prefix="pageVideos."
                update={update}
              />
            </SortableContainer.ItemWrapper>
          );
        })}
      </AssetsContainer>
    </div>
  );
};

export { PageVideoAssetsForm };
